<template>
    <div class="mobileApp gamegrade">
          <div class="banner_top">
            <banner-slide slide_width="100%" slide_height="100px" banner_pos="banner3" :slide_delay="20000" :isMobile="true"/>
        </div>  
        <div>
            <grac-search/>    
        </div>   
        <div class="post_summary">
            <post-summary menu_name='Gamegrade' :active='active'/> 
        </div>  
    </div>
</template>
<script>
import BannerSlide from '@/components/banner/BannerSlide';
import GracSearch from '@/mobile/pages/home/GracSearch'
import PostSummary from '@/mobile/components/posts/PostSummary';
export default {
    name:'mobile_gamegrade',
    props:[
        'active'   
    ],
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{        
        GracSearch,
        PostSummary,
        BannerSlide
    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
.gamegrade{
    .post_summary{
        margin-top:10px;
    }    
}
</style>